/* eslint-disable camelcase */
import { useEffect } from 'react';

// eslint-disable-next-line import/no-unresolved

import {
  addAssignedChannels,
  channelsMetadata,
  ChatStatus,
  getAssignedChannels,
  userIdSelector,
} from '@pharmaplan/common';

import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

const styles = {
  engaged: {
    backgroundColor: 'common.error',
  },
  available: {
    backgroundColor: 'pharmacist.availability',
  },
  assignedToMe: {
    backgroundColor: 'primary.main',
  },
  away: {
    backgroundColor: 'chatColors.orange500',
  },
};

const useChatStatus = (channel: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const dispatch = useAppDispatch();
  const channelData = useAppSelector(channelsMetadata);

  const userId = useAppSelector(userIdSelector);
  const assignedChannels = useAppSelector(getAssignedChannels);

  const { url } = channel ?? {};
  const metadata = channelData?.[url] ?? {};
  // eslint-disable-next-line camelcase
  const { users, username } = metadata ?? {};

  const statusHandler = () => {
    if (!users) return ChatStatus.available;
    if (users === userId) return ChatStatus.assignedToMe;
    if (users !== userId) return ChatStatus.engaged;

    return ChatStatus.available;
  };

  const statusConfig = {
    [ChatStatus.engaged]: {
      style: styles.engaged,
      label: `${strings.formatString(
        strings.engagedWithFormat,
        username ?? '',
      )}`,
    },
    [ChatStatus.available]: {
      style: styles.available,
      label: strings.available,
    },
    [ChatStatus.assignedToMe]: {
      style: styles.assignedToMe,
      label: strings.assignedToMe,
    },
    [ChatStatus.away]: {
      style: styles.assignedToMe,
      label: strings.away,
    },
  };

  const { label, style } = statusConfig[statusHandler()];
  const isNotEngaged = statusHandler() !== ChatStatus.engaged;

  useEffect(() => {
    if (users === userId) {
      dispatch(addAssignedChannels([...assignedChannels, url]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  return { label, style, isNotEngaged };
};

export default useChatStatus;
